import { useLocation, Navigate, Outlet } from "react-router-dom";
import jwt_decode from "jwt-decode";
import useAuth from "../hooks/useAuth";
import { ROLES } from "../constants/base";

// const RequireAuth = ({ allowedRoles }) => {
//   const { auth } = useAuth();
//   const location = useLocation();
//   const decoded = auth?.accessToken ? jwt_decode(auth.accessToken) : undefined;
//   const rolesArray = [decoded?.UserInfo?.role] || [];

//   // TO DO: use subtype to hide routes for USER (ANALYST, CELLAR_MANAGER, USER, ...)
//   return false || rolesArray.find((role) => allowedRoles?.includes(role)) ? (
//     <Outlet /> // any child component of RequireAuth
//   ) : (
//       auth?.username
//         ? <Navigate to="/unauthorized" state={{ from: location }} replace />
//         : <Navigate to="/login" state={{ from: location }} replace />
//   ); // ELSE --> the user isn't asking to be redirect to the login, so we force to that path
// };

// export default RequireAuth;

const RequireAuth = ({ allowedRoles = [], allowedRbacRoles = [], wineryScoped = false }) => {
  const { auth } = useAuth();
  const location = useLocation();

  if (!auth?.accessToken) {
    // Non loggato → redirect al login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const decoded = jwt_decode(auth.accessToken);

  // Ruoli globali (role principale dal token)
  const rolesArray = [decoded?.UserInfo?.role] || [];

  // RBAC roles dal token, esempio: [{ role_code: "ANALYST", winery_id: 8 }, ...]
  const rbacRoles = decoded?.UserInfo?.rbac_roles || [];
  const currentWineryId = decoded?.UserInfo?.winery_id;

  // Controllo ruoli globali
  const hasGlobalRole =
    allowedRoles.length === 0 || allowedRoles.some((r) => rolesArray.includes(r));

  // Controllo ruoli RBAC
  const hasRbacRole =
    allowedRbacRoles.length === 0 ||
    rbacRoles.some(
      (r) =>
        allowedRbacRoles.includes(r.role_code) &&
        (!wineryScoped || r.winery_id === currentWineryId)
    );

  if (Number(decoded?.UserInfo?.role)=== ROLES.ADMIN) {
    return <Outlet />;
  }
  if (hasGlobalRole && hasRbacRole) {
    return <Outlet />;
  }
  // Se loggato ma non autorizzato → unauthorized
  return <Navigate to="/unauthorized" state={{ from: location }} replace />;
};

export default RequireAuth;
